import {
  DOCTOR_BREADCRUMB_ROUTES,
  DOCTOR_HOME_PATH,
  TENANT_BREADCRUMB_ROUTES,
  TENANT_HOME_PATH,
} from "./breadcrumbConfig";

function resolveDynamicPath(dynamic, pathname, panelType) {
  if (dynamic === "file") {
    const match = pathname.match(/^\/files\/([^/]+)/);
    return match ? `/files/${match[1]}` : null;
  }
  if (dynamic === "patient") {
    const match = pathname.match(/^\/patients\/([^/]+)/);
    return match ? `/patients/${match[1]}` : null;
  }
  if (dynamic === "tenantPatient") {
    const match = pathname.match(/^\/tenant\/patients\/([^/]+)/);
    return match ? `/tenant/patients/${match[1]}` : null;
  }
  if (dynamic === "tenantDoctor") {
    const match = pathname.match(/^\/tenant\/doctors\/([^/]+)/);
    return match ? `/tenant/doctors/${match[1]}` : null;
  }
  return panelType === "tenant" ? TENANT_HOME_PATH : DOCTOR_HOME_PATH;
}

/**
 * @param {string} pathname
 * @param {"doctor" | "tenant"} panelType
 * @param {(key: string, ns: string) => string} translate
 * @param {string | null} [labelOverride]
 * @returns {Array<{ label: string, path: string | null }>}
 */
export function buildBreadcrumbItems(pathname, panelType, translate, labelOverride = null) {
  const routes = panelType === "tenant" ? TENANT_BREADCRUMB_ROUTES : DOCTOR_BREADCRUMB_ROUTES;
  const match = routes.find((route) => route.test(pathname));

  if (!match) {
    return [
      {
        label: translate("dashboard", panelType === "tenant" ? "tenantDashboard" : "sidebar"),
        path: null,
      },
    ];
  }

  const items = match.items.map((item, index) => {
    const isLast = index === match.items.length - 1;
    let path = null;

    if (!isLast) {
      if (item.path) {
        path = item.path;
      } else if (item.dynamic) {
        path = resolveDynamicPath(item.dynamic, pathname, panelType);
      }
    }

    return {
      label: translate(item.key, item.ns || "sidebar"),
      path,
    };
  });

  if (labelOverride && items.length > 0) {
    items[items.length - 1] = { ...items[items.length - 1], label: labelOverride };
  }

  return items;
}
